/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../store';

export type State = {
  [pageName: string]:
    | {
        open: boolean;
        id: string;
      }
    | undefined;
};

const initialState: State = {};

const slice = createSlice({
  name: 'pageShow',
  initialState,
  reducers: {
    showOpen: (state, action: PayloadAction<{ pageName: string; id: string }>) => {
      const { pageName, id } = action.payload;
      const pageShowData = state[pageName] || {};
      state[pageName] = { ...pageShowData, id, open: true };
    },
    showClose: (state, action: PayloadAction<{ pageName: string }>) => {
      const { pageName } = action.payload;
      const pageShowData = state[pageName] as {
        open: boolean;
        id: string;
      };
      state[pageName] = { ...pageShowData, open: false };
    },
  },
});

export const { showOpen, showClose } = slice.actions;

export const selectPageShow = (pageName: string) => (
  state: RootState
): {
  open: boolean;
  id: string;
} => {
  const pageShowData = state.pageShow[pageName] || { id: '', open: false };
  return pageShowData;
};

export default slice.reducer;
